import { render } from "./RoleInfo.vue?vue&type=template&id=35509a24&scoped=true"
import script from "./RoleInfo.vue?vue&type=script&lang=js"
export * from "./RoleInfo.vue?vue&type=script&lang=js"

import "./RoleInfo.vue?vue&type=style&index=0&id=35509a24&lang=stylus&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35509a24"]])

export default __exports__